import React from 'react';
import cn from 'classnames';

import { i18n } from '@lt/localization';

import { TOURISTS_COMPONENT_ID } from 'src/routes/Checkout/store/constants/tourists';

import MobileHeaderTitle from 'checkout/components/MobileHeader/MobileHeaderTitle';
import { RoomInfoHeader } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Room';
import TouristForm from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/containers/Tourists/TouristForm';
import NoOnlyMenValidationText from 'checkout/components/Tourists/OnlyMenWarning';
import Customer from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Customer';
import { HAS_CUSTOMER_FORM } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/components/Customer/abFeatures';
import { IS_NEW_TOURIST_VALIDATION } from 'src/store/touristsValidation/abFeatures';
import { ValidationRequestFailed, ValidationCommonErrors } from '../Validation';
import VisaInfoWarning from '../VisaInfoWarning';
import TouristFormMobile from '../../TouristFormMobile';
import { TouristsFooterDesktop } from '../TouristsFooterDesktop';

import { isTouristsValid, isMatchingHotelRequirements } from '../../utils';

const baseCls = 'checkout-tourists';

class Tourists extends React.PureComponent {
  render() {
    const {
      adultsCount,
      kidsAges,
      submit,
      isClientConfirmed,
      isPrebuildFetching,
      isPrebuilt,
      isMobile,
      isTouristPassportValidationInProgress,
      touristsPassportValidations = {},
      tourists = [],
      hotelFacts = {},
      isHotelOnly,
      isCustomerInfoValid,
      mobileCustomerFormVisible,
      showModalCustomer,
      isNewValidationTourist,
    } = this.props;

    const isValid = IS_NEW_TOURIST_VALIDATION
      ? isNewValidationTourist
      : isTouristsValid(tourists, touristsPassportValidations);

    const isMachingRequirments = isMatchingHotelRequirements(
      tourists,
      hotelFacts,
    );

    // TODO: feature customer_form - Убрать проверки на форму кастомера
    const btnDisabled =
      isPrebuildFetching ||
      !isPrebuilt ||
      !isValid ||
      (!isHotelOnly &&
        HAS_CUSTOMER_FORM &&
        showModalCustomer &&
        !isCustomerInfoValid);

    const showPreloader =
      isPrebuildFetching || isTouristPassportValidationInProgress;

    const touristsAges = [...Array(adultsCount).fill(null), ...kidsAges];

    const touristsCls = cn({
      disabled: !isClientConfirmed,
      [`${baseCls}--mobile`]: isMobile,
    });

    const FormComp = isMobile ? TouristFormMobile : TouristForm;

    const DataNotification = (
      <div className="data-notification">
        {i18n.t('checkout.touristForm.dataNotification')}
      </div>
    );

    // TODO: feature customer_form - Убрать showCustomerForm и showModalCustomer
    const showCustomerForm =
      (!isMobile && !isHotelOnly && HAS_CUSTOMER_FORM && showModalCustomer) ||
      (isMobile &&
        !isHotelOnly &&
        mobileCustomerFormVisible &&
        showModalCustomer &&
        HAS_CUSTOMER_FORM);

    return (
      <div className={baseCls} id={TOURISTS_COMPONENT_ID}>
        <div className={touristsCls}>
          <RoomInfoHeader />

          {isMobile && !isHotelOnly ? <MobileHeaderTitle /> : null}
          {DataNotification}
          <VisaInfoWarning />
          {touristsAges.map((age, idx) => {
            const key = `${age}-${idx}`;
            return <FormComp age={age} key={key} index={idx} />;
          })}

          {/* TODO: feature customer_form - Удалить Customer */}
          {showCustomerForm && <Customer />}

          {isMachingRequirments ? (
            <TouristsFooterDesktop
              submit={submit}
              isMobile={isMobile}
              btnDisabled={btnDisabled}
              showPreloader={showPreloader}
            >
              <ValidationCommonErrors />
              <ValidationRequestFailed />
            </TouristsFooterDesktop>
          ) : (
            <NoOnlyMenValidationText
              path={hotelFacts?.no_single_men.redirect_url}
            />
          )}
        </div>
      </div>
    );
  }
}

export { Tourists };
